 export const UsersLoginSystemLogPermissions =
 {
    ViewUsersLogin : {
        permissionsId: "dcca9c48-5396-4152-a5de-08db04f6cbfc",
        permissionsName: "View Users Login",
        componentsId: null,
        components: null
      }

 } ; 